const EventsPage = () => {
    return <h1 className="container mx-auto">Events Page</h1>
}

export default EventsPage;